import { useContext } from 'react';

import { NikeI18nContext } from '@nike/i18n-react';

export const useI18nContext = () => {
    return useContext(NikeI18nContext);
};
